import styled from 'styled-components';

export const Shell = styled.div`
	position: absolute;
	box-sizing: border-box;
	opacity: 0.5;
	filter: grayscale(1);

	&& {
		pointer-events: none;
	}
`;
